import { useSendCommand } from '@/_core/cqrs/use';
import { Action } from '@/_core/fluxstore/types';
import { SaveLastViewType } from '../../../api/commands';
import { StorymapState, ViewType } from '../../types';
import { useStorymapStore } from '../../useModule';
import { ClearMultiselection } from '../cardSelection/clearMultiselection';

const { registerReducer, registerMiddleware, dispatch } = useStorymapStore();

export class SetCurrentViewType extends Action<StorymapState> {
    public static ACTION_TYPE = 'SetCurrentViewType';

    public constructor(public viewType: ViewType, public trackingReleaseId: string | null = null) {
        super(SetCurrentViewType.ACTION_TYPE);
    }
}

const middleware = async (state: StorymapState, action: SetCurrentViewType): Promise<boolean> => {
    if (action.viewType === ViewType.Tracking) {
        dispatch(new ClearMultiselection());
    }

    if (state.isPublishedRecipient) {
        return true;
    }

    useSendCommand(action, {
        createCommand: () => new SaveLastViewType(state.id, action.viewType),
    });

    return true;
};

const reducer = (state: StorymapState, action: SetCurrentViewType): void => {
    state.currentViewType = action.viewType;
    state.trackingViewState.releaseId = action.viewType === ViewType.Tracking ? action.trackingReleaseId : null;
};

//@ts-ignore
registerMiddleware(SetCurrentViewType.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(SetCurrentViewType.ACTION_TYPE, reducer);
